export function toolGrantKey(tool) {
    if (!tool.name)
        return null;
    if (tool.kind === "builtin")
        return `builtin:${encodeURIComponent(tool.name)}`;
    if (tool.kind === "mcp" && tool.serverName)
        return `mcp:${[tool.agentName ?? "", tool.serverName, tool.name].map(encodeURIComponent).join(":")}`;
    return null;
}
/** The grant subject of a logged event; null for anything but a builtin or MCP tool use. */
export function toolGrantSubjectOf(event, agentName) {
    const name = typeof event.name === "string" ? event.name : null;
    if (!name)
        return null;
    if (event.type === "agent.tool_use")
        return { kind: "builtin", name };
    if (event.type === "agent.mcp_tool_use" && typeof event.mcp_server_name === "string")
        return { kind: "mcp", name, serverName: event.mcp_server_name, agentName };
    return null;
}
//# sourceMappingURL=tool-grants.js.map